const singleton = factory => {
	let instance = null;
	return globalContext => {
		instance = instance || factory(globalContext);
		return instance;
	};
};

export default singleton;
